import { LogLevel, PassedInitialConfig } from 'angular-auth-oidc-client';
import { environment } from '../../../environments/environment';

export function getAuthConfig(): PassedInitialConfig {
  return {
    config: {
      triggerAuthorizationResultEvent: true,
      authority: environment.oidc.baseUrl.replace(/\/$/, ''),
      // Cambia la raíz por una ruta de callback dedicada
      redirectUrl: `${window.location.origin}/auth/callback`,
      postLogoutRedirectUri: `${window.location.origin}/`,
      clientId: environment.oidc.clientId,
      scope: environment.oidc.scope,
      customParamsAuthRequest: { resource: environment.oidc.resource },
      customParamsCodeRequest: { resource: environment.oidc.resource },
      customParamsRefreshTokenRequest: { resource: environment.oidc.resource },
      responseType: 'code',
      silentRenew: true,
      useRefreshToken: true,
      renewTimeBeforeTokenExpiresInSeconds: 60,
      autoUserInfo: false,
      postLoginRoute: '/users',
      logLevel: environment.production ? LogLevel.Warn : LogLevel.Debug,
      secureRoutes: [environment.authApiUrl, environment.managementApiUrl],
    },
  } as PassedInitialConfig;
}
